export default {
  common: {
    ctaStartTrial: 'Empezar',
    ctaBookDemo: 'Reservar demo',
    noCreditCard: 'Empieza en minutos. Planes desde $49 al mes para 3 conductores.',
    faqTitle: 'Preguntas frecuentes',
    breadcrumb: {
      home: 'Inicio',
      resources: 'Recursos',
      features: 'Funciones',
      blog: 'Blog',
      caseStudies: 'Casos de estudio',
    },
  },
  nav: {
    builtFor: 'Por sector',
    features: 'Funciones',
    resources: 'Recursos',
    howItWorks: 'Cómo funciona',
    pricing: 'Precios',
    partners: 'Socios',
    integrations: 'Integraciones',
    contact: 'Contacto',
    login: 'Iniciar sesión',
    getStarted: 'Empezar',
    mobileLanguage: 'Idioma',
    comingSoon: 'Próximamente',
    panels: {
      builtFor: {
        title: 'Soluciones por sector',
        subtitle: 'Gestión de flotas adaptada a las necesidades de tu sector.',
        viewAll: 'Ver todos los sectores',
        useCases: 'Sectores',
        useCasesSub: 'Agrupados — elige el tuyo o ver todos.',
        groupFoodHealth: 'Alimentación, salud y supermercados',
        groupRetailCommerce: 'Retail, e‑commerce y distribución',
        groupLogisticsField: 'Logística y operaciones de campo',
        industryBenefitsTitle: 'Beneficios por sector',
        industryBenefitsSub: 'Resultados contrastados en todos los sectores',
        quickAccessTitle: 'Acceso rápido',
        successStory: 'Caso de éxito',
        successStoryTitle: 'Cómo las empresas reducen los costes de entrega un 20–30%',
        successStoryDesc: 'Descubre cómo las principales empresas de logística usan Geofleet para optimizar operaciones.',
        readCaseStudy: 'Ver caso de éxito',
        readyToOptimize: '¿Listo para optimizar las operaciones de tu sector?',
        getIndustryDemo: 'Solicitar demo por sector',
      },
      features: {
        title: 'Funciones de la plataforma',
        subtitle: 'Herramientas con IA para entrega, rutas, prueba de entrega y operaciones de flota.',
        viewAll: 'Ver todas las funciones',
        trackingDelivery: 'Seguimiento y entrega',
        trackingDeliverySub: 'Herramientas para clientes y conductores',
        operationsInsights: 'Operaciones e insights',
        operationsInsightsSub: 'Automatización, finanzas y análisis',
        aiFirst: 'IA primero',
        everyFeaturePowered: 'Cada función impulsada por IA',
        automatingDecisions: 'Automatizando decisiones, prediciendo resultados y aprendiendo de tus datos.',
        startFreeTrial: 'Empezar',
        getDemo: 'Reservar demo',
        readyToAutomate: '¿Listo para automatizar tus operaciones de entrega?',
      },
      resources: {
        title: 'Recursos',
        subtitle: 'Casos de éxito, guías y soporte.',
        viewAll: 'Ver todos los recursos',
        learning: 'Formación',
        successStories: 'Casos de éxito',
        support: 'Soporte',
        latestReport: 'Guía',
        lastMile2026: 'Cómo funciona Geofleet',
        lastMileDesc: 'Seis pasos desde el pedido hasta la prueba de entrega.',
        readReport: 'Leer la guía',
        needHelp: '¿Necesitas ayuda para empezar?',
        contactExperts: 'Contactar con expertos',
      },
    },
    items: {
      builtFor: {
        restaurants: { label: 'Restaurantes y QSR', description: 'Entregas más rápidas, mejor servicio' },
        pharmacies: { label: 'Farmacias', description: 'Entrega fiable de recetas' },
        retail: { label: 'Retail', description: 'Simplifica las entregas minoristas' },
        ecommerce: { label: 'E-commerce', description: 'Escala tu tienda online' },
        couriers: { label: 'Mensajería y logística', description: 'Gestiona conductores y rutas' },
        laundry: { label: 'Lavandería y tintorería', description: 'Recogida y entrega' },
        flowers: { label: 'Flores y regalos', description: 'Entregas urgentes' },
        water: { label: 'Agua a domicilio', description: 'Gestión de rutas recurrentes' },
        fuel: { label: 'Combustible y gas', description: 'Logística de combustible bajo demanda' },
        manufacturing: { label: 'Manufactura', description: 'Última milla en la cadena de suministro' },
        grocery: { label: 'Supermercados', description: 'Franjas, rutas densas, sustituciones' },
        'b2b-distribution': { label: 'B2B y mayoristas', description: 'Software de entrega distribución' },
        'medical-supplies': { label: 'Médico y laboratorios', description: 'Muestras, kits, ventanas horarias' },
        'field-service': { label: 'Servicio de campo', description: 'Citas, repuestos, camiones' },
        'building-supplies': { label: 'Construcción y voluminoso', description: 'Cargas pesadas, ventanas, POD' },
        'automotive-parts': { label: 'Recambios automoción', description: 'Mismo día y redes concesionarios' },
        'contract-logistics': { label: '3PL y contrato', description: 'SLAs y portales multi-cliente' },
      },
      features: {
        brandedTracking: { label: 'URL de seguimiento con marca', description: 'Páginas de seguimiento para clientes' },
        routePlanner: { label: 'Planificador de rutas', description: 'Rutas multi-parada optimizadas con IA' },
        aiAgents: { label: 'Agentes IA', description: 'Automatiza el despacho y las operaciones' },
        proofOfDelivery: { label: 'Prueba de entrega', description: 'Fotos, firmas y marcas de tiempo' },
        autoAllocation: { label: 'Asignación automática', description: 'Agentes IA asignan pedidos a conductores' },
        cashManagement: { label: 'Gestión de efectivo', description: 'Seguimiento de pagos contra reembolso' },
        reportsAnalytics: { label: 'Informes y análisis', description: 'Insights de rendimiento con IA' },
        driverApp: { label: 'App conductor', description: 'Seguimiento en tiempo real y herramientas' },
      },
      resources: {
        caseStudies: { label: 'Casos de éxito', description: 'Historias de clientes' },
        blog: { label: 'Blog', description: 'Tendencias e ideas por sector' },
        roiCalculator: {
          label: 'Calculadora ROI',
          description: 'Estima el ahorro por menos retrasos y mejor uso de la flota',
        },
        whitepapers: { label: 'Whitepapers', description: 'Investigación y guías en profundidad' },
        blogArticles: { label: 'Blog y artículos', description: 'Tendencias y mejores prácticas' },
        webinars: { label: 'Webinars y eventos', description: 'Sesiones en vivo y grabaciones' },
        customerSuccess: { label: 'Éxito del cliente', description: 'Cómo las empresas logran ROI' },
        helpCenter: { label: 'Centro de ayuda' },
        apiDocs: { label: 'Documentación API' },
      },
      industryBenefits: {
        fasterDeliveries: { value: '30%', label: 'Entregas más rápidas', description: 'Rutas optimizadas reducen tiempos.' },
        costReduction: { value: '20–30%', label: 'Reducción de costes', description: 'Menor combustible y costes operativos.' },
      },
      quickAccess: {
        helpCenter: 'Centro de ayuda',
        contactSupport: 'Contactar soporte',
      },
    },
  },
};
